
<script>
import { APIS } from "./constantes/apis";
import $ from "jquery";
import {  encryptData,decryptData } from '../src/constantes/encrypt';

export default {
  data: function () {
    return {
      footer: true,
      APIS: APIS,
      statys: false,
      idEntidad: "id",
      titlePage: "",
      social: {
        facebookPage: "https://www.facebook.com/",
        twitterPage: "https://www.twitter.com/",
        instagramPage: "https://www.instagram.com/",
        youtubePage: "https://www.youtube.com/",
      },

      colorpPage: "",
      colorsPage: "",
      logovPage: "url",
      logohPage: "url",
      copyright: "",
      contacto: "",
      correo: "",
      favicon: "",
      lema: "Juntos como nunca",
      header: {
        latitud: "",
        longitud: "",
        idEntity: null,
        token: "",
      },
    };
  },
  beforeMount() {
    this.getLocate();
    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    const body = { 
      data: encryptData({ idEntity: process.env.VUE_APP_ENTIDAD, "process": "ENTITY_GET_ONLY" })
     
    };
    this.$http
      .post(this.APIS[1].name, body)
      .then( (response) => {
        
        response.data.data =  decryptData(response.data.data)
        this.header.token = response.data.token;
        this.logohPage = response.data.data.logo_primario;
        this.colorpPage = response.data.data.color_primario;
        this.colorsPage = response.data.data.color_secundario;
        this.copyright = response.data.data.copyright;
        this.contacto = response.data.data.contacto;
        this.correo = response.data.data.correo;
        this.social.facebookPage = response.data.data.facebook;
        this.social.twitterPage = response.data.data.twitter;
        this.favicon = response.data.data.favicon;
        this.header.idEntity = process.env.VUE_APP_ENTIDAD;
        window.document.title = response.data.data.titlePage;
        this.titlePage = response.data.data.titlePage;
        $(":root").css("--colorP", response.data.data.color_primario);
        $(":root").css("--colorS", response.data.data.color_secundario);
        link.href = this.favicon;
      })
      .catch((error) => {
        console.log('error en peticion ', error);
        this.$router.push("/error");
        return 404;
      });
  },
  methods: {
    async getLocate() {
      var globales = this;
      navigator.geolocation.getCurrentPosition(function (position) {
        globales.header.longitud = position.coords.longitude;
        globales.header.latitud = position.coords.latitude;
        //console.log(globales.header.latitud);
      });
    },

    listen(variable) {
      console.log(variable);
    },
    closeSesion() {
      this.$session.clear();
      this.$session.destroy();
      window.location.href = "/";
      this.$router.push("/");
    },
  },
  mounted: function () { },
};
</script>

<template>
  <div id="app">
    <div id="nav">
      <img class="icon-nav" :src="this.logohPage" />
      <!-- <router-link to="/registro">Registro</router-link> |
            <router-link to="/inicio">Login</router-link> -->
      <div v-show="this.$session.exists()" id="content-user">
        <div id="exit"><a href="#" @click="closeSesion">Salir</a></div>
      </div>
    </div>

    <router-view :APIS="APIS" :copyright="this.copyright" :title="this.titlePage" :header="this.header"
      :social="this.social" @listening="listen" />

    <!-- 
          <div v-if="!this.$session.exists()" id="footer">
            <p>{{this.copyright}}</p>
            <a :href="this.facebookPage" target="_blank"> <i class="fa fa-facebook-official" aria-hidden="true"></i></a>
            <a :href="this.twitterPage" target="_blank"><i class="fa fa-twitter-square" aria-hidden="true"></i></a>
            <a :href="this.instagramPage" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>
            <a :href="this.youtubePage" target="_blank"><i class="fa fa-youtube-play" aria-hidden="true"></i></a>
          </div>
          -->
  </div>
</template>

<style scoped></style>
